function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

/*
  V122 (20 okt 2026) - BUGFIX bezorgdatum.
  De oude versie rekende de tijd tot middernacht uit met
  `new Date(ora.setHours(24,0,0,0)) - ora`. setHours() past `ora` ZELF aan,
  dus die aftreksom was altijd 0. Gevolg: aggiornaData() plande zichzelf
  elke paar milliseconden opnieuw in - zo'n 200 keer per seconde, de hele
  tijd dat de pagina openstond - en elke keer dwong innerText een layout
  van de complete pagina af. PageSpeed schreef dit script 1,3 s CPU toe
  ("Reduce JavaScript execution time"). Nu: een keer bij laden, een keer om
  middernacht, daarna een keer per dag. textContent i.p.v. innerText, zodat
  er geen layout wordt afgedwongen.
*/
document.addEventListener('DOMContentLoaded', function() {
  var doubleuspsElement = document.querySelector('.doubleusps');
  if (!doubleuspsElement) {
    return;
  }

  var giorniDellaSettimana = (doubleuspsElement.dataset.giorni || '').split(',');
  var mesi = (doubleuspsElement.dataset.mesi || '').split(',');
  var nDays = window.nDays || 1;
  var cstmDate = document.getElementById('cstmdate');

  function aggiornaData() {
    var ora = new Date();
    var futureDate = new Date(ora.getTime());
    futureDate.setDate(ora.getDate() + nDays);

    var dataFormattata = (giorniDellaSettimana[futureDate.getDay()] || '').trim() + ', ' +
      futureDate.getDate() + ' ' + (mesi[futureDate.getMonth()] || '').trim();

    if (cstmDate && cstmDate.textContent !== dataFormattata) {
      cstmDate.textContent = dataFormattata;
    }
  }

  function planMiddernacht() {
    var nu = new Date();
    var middernacht = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1, 0, 0, 1, 0);
    var wacht = Math.max(1000, middernacht.getTime() - nu.getTime());
    setTimeout(function () {
      aggiornaData();
      planMiddernacht();
    }, wacht);
  }

  aggiornaData();
  planMiddernacht();
});
